enum ProfessionalTypeEnum
{
    Undefined = 0,
    Business = 1,
    Collectivity,
    EPCI,
    Association
}

export default ProfessionalTypeEnum;